<div class="row mb-4 mt-5" *ngIf="!hideStep">
  <div class="col d-none d-md-block d-lg-block"></div>
  <div class="col">
    <ul class='StepTimeline mt-5'>
      <li [class]='i <= itemActive ? "active" : ""' *ngFor="let item of itens; let i = index">
        <span *ngIf="i === itemActive" class="TooltipStep">
          {{item}}
        </span>
      </li>
    
    </ul>
  </div>
  <div class="col d-none d-md-block d-lg-block"></div>
</div>
